<form [formGroup]="myForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate>

  <h2 mat-dialog-title style="margin-bottom: 0px">{{title}}</h2>
  <mat-divider style="margin-bottom: 8px;"></mat-divider>

  <div> <!--fxLayout="column" fxLayoutAlign=" none" fxLayoutGap="15px" -->

    <mat-form-field>
      <mat-label>Agency Name:</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>


    <div mat-dialog-actions>
      <button mat-button type="button" (click)="dialogRef.close('cancel')" color="accent">Cancel</button>
      <!--<button mat-button (click)= "update()"   cdkFocusInitial>Create</button>-->
      <button mat-raised-button [disabled]="!myForm.valid" type="submit" color="primary">
        {{button_text}}
      </button>
    </div>

  </div>


</form>
